var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 57.0402C0 25.5377 25.5377 0 57.0402 0C88.5426 0 114.08 25.5377 114.08 57.0402C114.08 88.5426 88.5426 114.08 57.0402 114.08C25.5377 114.08 0 88.5426 0 57.0402Z",
    fill: "#095D7E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_6196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1913 58.7687L48.5745 69.8855C46.9946 70.8279 44.967 69.6867 44.967 67.7868V45.5531C44.967 43.6562 46.9917 42.512 48.5745 43.4574L67.1913 54.5742C67.5507 54.7854 67.8494 55.0906 68.0572 55.4589C68.265 55.8272 68.3744 56.2456 68.3744 56.6715C68.3744 57.0973 68.265 57.5157 68.0572 57.884C67.8494 58.2523 67.5507 58.5575 67.1913 58.7687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_6196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4074,
    height: 28.3353,
    fill: "white",
    transform: "translate(45.3367 42.8726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.349487336246adb4e4dfc1040e5a5802.svg";
export { ForwardRef as ReactComponent };